import { effects } from 'redux-saga'
import { parse } from 'query-string'
import { push as pushPath } from 'react-router-redux'

import {
  advanceToOffer,
  setAddress,
  selectOffer,
} from '../../modules/signupEdit/actions'

export default function* begin(action) {
  if (!action.payload.location) {
    return
  }

  const hash = yield effects.call(parse, action.payload.location.hash)

  if (hash.offer) {
    yield effects.put.resolve(selectOffer(parseInt(hash.offer, 10)))
  }

  if (hash.address) {
    yield effects.put.resolve(setAddress(hash.address))
    yield effects.put.resolve(advanceToOffer())

    return
  }

  yield effects.put.resolve(pushPath('/'))
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/begin.js